import { DocumentHit, SearchCategory, SearchHit } from '@common/types/search';
import { CategoryResults } from '@components/display/search';
import { useEffect, useState } from 'react';
import { Configure, Index } from 'react-instantsearch';
import { useIntl } from 'react-intl';

export const CategoryIndex = <T extends SearchHit | DocumentHit = SearchHit | DocumentHit>({
    category,
    search,
    RenderComponent,
    initialHitsPerPage = 3,
}: {
    category: SearchCategory<T>;
    search: string;
    RenderComponent?: React.ElementType;
    initialHitsPerPage?: number;
}) => {
    const [hitsPerPage, setHitsPerPage] = useState(initialHitsPerPage);
    const intl = useIntl();
    const categoryName = intl.formatMessage(category.name);

    const handleShowNext = (newHitsPerPage: number) => {
        setHitsPerPage(newHitsPerPage);
    };

    useEffect(() => {
        setHitsPerPage(initialHitsPerPage);
    }, [search, initialHitsPerPage]);

    return (
        <Index EXPERIMENTAL_isolated key={category.index} indexName={category.index} indexId={categoryName}>
            <Configure query={search} hitsPerPage={hitsPerPage} />
            <CategoryResults
                name={categoryName}
                Icon={category.icon}
                search={search}
                onShowNext={handleShowNext}
                urlIn={category.in}
                url={category.url}
                RenderComponent={RenderComponent}
                hitsPerPage={hitsPerPage}
                downloadable={category.downloadable}
                chip={category.chip}
                title={category.title}
            />
        </Index>
    );
};
